import StaffOptionSorting from '../common/option-sorting/StaffOptionSorting';
import StaffTable from '../layout/Admin/StaffTable';

export default function Staff() {

    return (
        <div className='bg-white rounded-md w-full h-full p-4 flex-1 flex flex-col space-y-3 overflow-hidden'>
            <StaffOptionSorting/>
            <StaffTable/>
        </div>
    )
}
